import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page card-id-view" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " arrow_back ", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" back to my card ")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  class: "button is-link",
  style: {"margin-top":"12px"},
  disabled: ""
}, "Save on Scrolldex", -1)
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_card_read = _resolveComponent("card-read")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isUserLoggedIn)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "return-to-my-card",
          onClick: _cache[0] || (_cache[0] = () => _ctx.router.push('/'))
        }, _hoisted_4))
      : _createCommentVNode("", true),
    (!_ctx.cardData)
      ? (_openBlock(), _createBlock(_component_loader, { key: 1 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createVNode(_component_card_read, {
            "read-only": "",
            cardData: _ctx.cardData
          }, null, 8, ["cardData"]),
          _hoisted_5,
          _createElementVNode("a", {
            class: "button download",
            style: {"margin-top":"12px"},
            download: "",
            href: _ctx.downloadUrl
          }, "Add to Contacts", 8, _hoisted_6)
        ], 64))
  ]))
}